<template>
    <div class="page-with-top-bar">

      <section>
        <div class="mt-4">
          <b-tabs type="is-boxed" v-model="mainActiveTab">

            <!-- classes -->
            <b-tab-item>
              <template slot="header">
                <b-icon pack="fas" icon="file"></b-icon>
                <span> {{ $t('issue_classification') }} </span>
              </template>
              <div>
              </div>
              <issue-c-t-d-o
                ref="project_issue_classes"

                option='classes'
                :companyId="company.id"
              ></issue-c-t-d-o>
            </b-tab-item>

            <!-- types -->
            <b-tab-item>
              <template slot="header">
                <b-icon pack="fas" icon="file"></b-icon>
                <span> {{ $t('issue_types') }} </span>
              </template>

              <issue-type
                ref="project_issue_types"
                :companyId="company.id"

                option='types'
              ></issue-type>
            </b-tab-item>

            <!-- disciplines -->
            <b-tab-item>
              <template slot="header">
                <b-icon pack="fas" icon="file"></b-icon>
                <span> {{ $t('issue_disciplines') }} </span>
              </template>

              <issue-c-t-d-o
                ref="project_issue_disciplines"

                option='disciplines'
                :companyId="company.id"
              ></issue-c-t-d-o>
            </b-tab-item>

            <!-- origins -->
            <b-tab-item>
              <template slot="header">
                <b-icon pack="fas" icon="file"></b-icon>
                <span> {{ $t('issue_origins') }} </span>
              </template>
              <issue-c-t-d-o
                ref="project_issue_origins"

                :companyId="company.id"
                option='origins'
              ></issue-c-t-d-o>
            </b-tab-item>
            <!-- codification -->
            <b-tab-item>
              <template slot="header">
                <b-icon pack="fas" icon="file"></b-icon>
                <span> {{ $t('codification') }} </span>
              </template>
              <issue-codification/>
            </b-tab-item>

          </b-tabs>
        </div>
      </section>
    </div>
  </template>

  <script>
    import {mapGetters} from "vuex";
    import Form from "vform";
    import IssueCTDO from "./issue-c-t-d-o";
    import IssueType from "./issue-type";
    import IssueCodification from "./issue-codification.vue";
    // import ProjectAdminQuickButtons from '·/components/project-admin-quick-buttons';
    import EventBus from '~/plugins/bus';

    export default {
      middleware: "auth",
      title: 'issues_management',
      menuOption: "0-8",
      subtitle: "issues_page_title",

      components: {
        // ProjectAdminQuickButtons,
        IssueCTDO,
        IssueType,
        IssueCodification,
      },

      computed: {
        ...mapGetters({
          navData: "app/navData",
          user: "auth/user",
          company: "app/company",
        }),
        // projectId() {
        //   return parseInt(this.navData.project_id);
        // }
      },

      data: () => ({
        isLoading: false,
        form: new Form({
          projectId: null,
          partnerId: null,
          companyId: null,
          excelFile: null,
          description: "",
          overwrite: false,
          assignmentType: null,
          activityCode: null,
          actionType: "",
        }),

        entityType: 'project',
        entityId: null,

        errors: [],
        mainActiveTab: 0,
        addDrawings: false,
      }),

      watch: {
        mainActiveTab(value) {
          if (value == 0) {
            // no aplicable
            //this.$refs.project_assignments_manual.reload();
          }
        }
      },

      created() {
        let projectName = this.navData.project_name
          ? this.navData.project_name.toUpperCase()
          : "";
        // this.$options.subtitle = ["project_actions_page_subtitle", [projectName]];

        this.entityId = this.projectId;
      },

      mounted() {
        let self = this;
        // Si recibimos el evento refresh, refrescamos el componente
        EventBus.$on("refreshProjectDocumentsNotifications", function(e) {
          if( e.executor_user_id && e.executor_user_id != self.user.id ) {
            self.refreshProjectDocuments();
          } else {
          }
        });
      },

      beforeDestroy(){
        EventBus.$off("refreshProjectDocumentsNotifications");
      },

      methods: {

        onAddClicked(modal='documents') {
          this.addDrawings = modal == 'drawings'
          this.$refs.modal.show();
        },

        successfullyUploaded() {

          if( this.addDrawings )
            this.$refs.project_drawings_manual.reload();
          else
            this.$refs.project_documents_manual.reload();

          // let entity = this.entityType;
          // entity = entity.charAt(0).toUpperCase() + entity.slice(1);

          //Evento : "refreshActivityDocumentsNotifications"
          // EventBus.$emit('refresh'+entity+'DocumentsNotifications', true);
        },

        refreshProjectDocuments() {
          this.$refs.project_drawings_manual.reload();
          this.$refs.project_documents_manual.reload();
        },
      }
    };
  </script>
